import DataSources from "@/components/admin/DataSources";

const InboundMcpServers = () => {
  return (
    <div className="flex flex-1 flex-col min-h-0 overflow-auto">
      <DataSources />
    </div>
  );
};

export default InboundMcpServers;
